import { render, staticRenderFns } from "./ClientSay.vue?vue&type=template&id=7d084524&scoped=true&"
import script from "./ClientSay.vue?vue&type=script&lang=js&"
export * from "./ClientSay.vue?vue&type=script&lang=js&"
import style0 from "./ClientSay.vue?vue&type=style&index=0&id=7d084524&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d084524",
  null
  
)

export default component.exports